import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingIndicator = ({ show }) => {
    return (
        <Backdrop open={show}
            sx={{
                color: '#46B8DA',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
            }}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};

export default LoadingIndicator;
